import { colors } from './const';
import { checkNodeVersion } from './utils/nodeCheck';
import { checkVercelCli } from './utils/vercelCliCheck';
import { checkVercelLogin } from './utils/vercelLoginCheck';
import { runVercelDeploy } from './utils/vercelDeploy';
import { assertDeployAllowed } from './workflow-state';
import { resolveProjectRoot } from './resolve-project-root';

export async function runDeployment() {
  assertDeployAllowed(resolveProjectRoot());

  console.log(`\n${colors.bold}${colors.cyan}🚀 Starting CFM Vercel Deployment...${colors.reset}\n`);

  await checkNodeVersion();
  const { useNpx } = await checkVercelCli();
  const hasToken = await checkVercelLogin(useNpx);
  await runVercelDeploy(useNpx, hasToken);
}
